import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { HBox, VBox } from '../../../components/Box';
import { Loader } from '../../../components/Loader';
import { Calendar } from '../../../components/Icon';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

import { updateTransportOrderFilter } from '../actions';
import { selectTransportOrderFilter, selectTransportOrderSeparateListFilter } from '../selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANIES_SEARCH } from '../../Companies/constants';
import { REQUEST_USER } from '../../Users/constants';
import styles from './TransportOrderFilter.module.css';

const Container = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    // position: absolute;
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }
`;

const STATE = {
  selectedValues: [],
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  altValue: null,
  showOptions: false,
  min: null,
  max: null,
  minDate: null,
  maxDate: null,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrderFilterFilterComp extends BaseComponent {
  constructor(props) {
    let filterPair = props.filter?.properties?.find(f => f.key === props.name);
    let filterValue = filterPair?.value;
    let filterLabel = filterPair?.label;
    let updateState = {};
    if (filterValue) {
      switch (props.type) {
        case 'single':
          updateState = { selectedValue: filterValue[0] ?? null, selectedLabel: filterLabel[0] ?? '' };
          break;
        case 'multiple':
          updateState = { selectedValues: filterValue ?? [], selectedLabels: filterLabel ?? [] };
          break;
        case 'ranged_date':
          updateState = {
            minDate: filterValue[0] ?? null,
            maxDate: filterValue[1] ?? null,
            selectedLabels: filterLabel ?? [],
          };
      }
    }

    super(props, {
      ...STATE,
      ...updateState,
      search: props.filter?.searchString || '',
    });

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedValue !== this.state.selectedValue && !this.props.altKey) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        if (this.props.name === 'has_ordered') {
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_outgoing_order');
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_incoming_product_order');
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel], 'has_product_ordered');
        } else {
          this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel]);
        }
      }
    }
    if (!_.isEqual(prevState.selectedValues, this.state.selectedValues) && !this.props.buttonFilter) {
      if (!this.state.selectedValues.length) {
        this.props.reset();
      } else {
        this.props.changeValues(this.state.selectedValues, this.state.selectedLabels);
      }
    }

    if (prevState.min !== this.state.min || prevState.max !== this.state.max) {
      this.props.changeValues([this.state.min ?? '0', this.state.max ?? '0']);
    }

    if (prevState[this.props.search] !== this.state[this.props.search]) {
      this.props.changeValues([this.state[this.props.search] + ''], [this.state.searchLabel]);
    }
    if (prevState.minDate !== this.state.minDate || prevState.maxDate !== this.state.maxDate) {
      this.props.changeValues([this.state.minDate, this.state.maxDate], this.state.selectedLabels);
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  compareLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  };

  get options() {
    if (this.props.name === 'transporterId') return this.props.options;
    if (this.props.noModify && this.props.options?.length) {
      return this.props.options?.map(o => ({ label: o?.label, value: o?.value + '' }))?.sort(this.compareLabel);
    }
    const res = !!this.props.isBool ? [] : [{ label: `${this.lblStr('transport_order.filter.empty')}`, value: '-' }];
    const optionsToParse = this.props.isBool
      ? ['no', 'yes']
      : this.props.search
      ? []
      : this.props.options?.sort((a, b) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else return 0;
        });

    return res.concat(
      optionsToParse
        ?.map(value => {
          let lbl = this.lblStr(`transport_order.filter.${value}`) ?? '';

          return {
            label: `${lbl}` ?? value,
            value: this.props.isBool ? (value === 'yes' ? '1' : value === 'no' ? '0' : null) : value,
          };
        })
        ?.sort(() => this.compareLabel),
    );
  }

  get multiOptions() {
    if (this.props.noModify) return this.props.options?.sort(this.compareLabel);
    if (this.props.name === 'status') {
      return this.props.options?.map((option, code) => ({ label: option, value: code + '' }))?.sort(this.compareLabel);
    }
    if (this.state.text) {
      return this.props.options
        ?.filter(option => option?.toLowerCase()?.includes(this.state.text.toLowerCase()))
        ?.map(option => ({ label: option, value: option.toLowerCase() }))
        ?.sort(this.compareLabel);
    }
    return [{ label: `${this.lblStr('transport_order.filter.empty')}`, value: '-' }].concat(
      this.props.options
        ?.map(option => {
          return { label: this.lblStr(`${option}`), value: option.toLowerCase() };
        })
        ?.sort(this.compareLabel),
    );
  }

  get value() {
    return this.options.find(o => o.value === this.props.filterSingleValue);
  }

  getFilterValueByName(filterName) {
    return this.props.filter.properties?.find(p => p.key === filterName)?.value?.[0];
  }

  renderDateFilter = () => {
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value;
    let selMin = selected?.length ? selected[0] : null;
    let selMax = selected?.length ? selected[1] : null;
    let formatMin = selMin?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMin = selMin && dayjs(selMin, formatMin);
    let formatMax = selMax?.charAt(2) === '-' ? 'DD-MM-YYYY' : undefined;
    let selectedMax = selMax && dayjs(selMax, formatMax);
    const updateLabels = this.state.selectedLabels;
    return (
      <HBox
        left
        flip={window.innerWidth < 768}
        className={cn({ [styles.rangedDatePickerContainer]: window.innerWidth > 768 && !this.props.overview })}
      >
        <HBox left>
          <div className={styles.Container}>
            <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
              <div className={styles.Label}>Van</div>
              <DatePicker
                className={styles.datePicker}
                placeholder={'from'}
                dateFormat="dd-MM-yyyy"
                selected={selectedMin && dayjs(selectedMin).isValid() ? selectedMin.toDate() : null}
                onChange={date => {
                  if (!date) {
                    this.setState({ minDate: null });
                    return;
                  }

                  let d = dayjs(date).format('DD-MM-YYYY');
                  this.setState({
                    minDate: d,
                    selectedLabels: [...updateLabels.slice(0, 1), d],
                  });
                }}
              />
              <Calendar className={styles.iconCalendar} />
            </div>
          </div>
          <div className={styles.Container}>
            <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
              <div className={styles.Label}>Tot</div>
              <DatePicker
                className={styles.datePicker}
                dateFormat="dd-MM-yyyy"
                selected={selectedMax ? selectedMax.toDate() : null}
                onChange={date => {
                  if (!date || !dayjs(date).isValid()) {
                    console.error('Invalid date selected:', date);
                    return;
                  }

                  let d = dayjs(date).format('DD-MM-YYYY');
                  this.setState({
                    maxDate: d,
                    selectedLabels: [...updateLabels.slice(0, 1), d],
                  });
                }}
              />
              <Calendar className={styles.iconCalendar} />
            </div>
          </div>
        </HBox>
        <div className={styles.ContainerButton}>
          <ButtonComponent
            onClick={() => {
              if (this.props.name === 'dateToPlan') {
                const today = dayjs().format('DD-MM-YYYY');
                const updateLabels = [...(this.state.selectedLabels || [])];
                updateLabels[0] = today; // Set only the first value
                this.setState(
                  {
                    minDate: today,
                    selectedLabels: updateLabels,
                  },
                  () => {
                    this.props.changeValues([this.state.maxDate, today], updateLabels);
                  },
                );
              } else {
                const today = dayjs().format('DD-MM-YYYY');
                this.setState(
                  {
                    minDate: today,
                    maxDate: today,
                    selectedLabels: [today, today],
                  },
                  () => {
                    this.props.changeValues([today, today], [today, today]);
                  },
                );
              }
            }}
          >
            Vandaag
          </ButtonComponent>
          <ButtonComponent
            onClick={() => {
              if (this.props.name === 'dateToPlan') {
                const Tomorrow = dayjs()
                  .add(1, 'day')
                  .format('DD-MM-YYYY');
                const updateLabels = [...(this.state.selectedLabels || [])];
                updateLabels[0] = Tomorrow; // Set only the first value
                this.setState(
                  {
                    minDate: Tomorrow,
                    selectedLabels: updateLabels,
                  },
                  () => {
                    this.props.changeValues([this.state.maxDate, Tomorrow], updateLabels);
                  },
                );
              } else {
                const Tomorrow = dayjs()
                  .add(1, 'day')
                  .format('DD-MM-YYYY');
                this.setState(
                  {
                    minDate: Tomorrow,
                    maxDate: Tomorrow,
                    selectedLabels: [Tomorrow, Tomorrow],
                  },
                  () => {
                    this.props.changeValues([Tomorrow, Tomorrow], [Tomorrow, Tomorrow]);
                  },
                );
              }
            }}
          >
            Morgen
          </ButtonComponent>
        </div>
      </HBox>
    );
  };

  renderSingleFilter = () => {
    const handleChange = pair => {
      console.log(pair);
      return pair.value === null
        ? this.props.setState({ selectedValue: null, selectedLabel: '' })
        : this.setState({ selectedValue: pair.value, selectedLabel: pair.label });
    };

    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.label[0];

    if (this.props.userId) {
      selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value[0];
      if (this.props.workUser)
        return (
          <HBox style={{ height: '55px' }}>
            <Loader small />
          </HBox>
        );
    }

    return (
      <SearchSelect
        minWidth={'100%'}
        maxWidth={'100%'}
        placeholder={this.props.label ?? this.lblStr(`transport_order.filter.${this.props.name}`)}
        options={this.options}
        value={selected && { label: selected }}
        onChange={handleChange}
        className="filter"
      />
    );
  };

  toggleOption = (value, label, option) => {
    this.setState(state => {
      if (option == 'buttonFilter') {
        return {
          selectedValues: state.selectedValues.includes(value)
            ? state.selectedValues.filter(v => v !== value)
            : [...state.selectedValues, value],
          selectedLabels: state.selectedLabels.includes(label)
            ? state.selectedLabels.filter(l => l !== label)
            : [...state.selectedLabels, label],
        };
      }
      return {
        selectedValues: [...value],
        selectedLabels: [...label],
      };
    });
  };

  handleMultiselectSearch = e => {
    this.setState({ text: e.target.value, showOptions: !!e.target.value?.length });
  };

  renderMultipleFilter = () => {
    const label = this.props.label ?? this.lblStr(`transport_order.filter.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name);
    let selectedResult = [];

    selected?.value?.map((val, index) => {
      selectedResult?.push({
        value: val,
        label: selected?.label[index],
      });
    });

    return (
      <SearchSelect
        isMulti
        closeMenuOnSelect={false}
        minWidth={'100%'}
        maxWidth={'100%'}
        value={selectedResult}
        onChange={e => {
          const values = e.map(item => item.value);
          const labels = e.map(item => item.label);
          this.toggleOption(values, labels);
        }}
        placeholder={label}
        options={this.multiOptions}
      />
    );
  };

  handleClickOutside = e => {
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target) && !!this.state.showOptions) {
      this.setState({ showOptions: false });
    }
  };

  render() {
    return (
      <Container minWidth={this.props.minWidth} controlWidth={this.props.controlWidth}>
        {this.props.type === 'single' && !this.props.search && this.renderSingleFilter()}
        {this.props.type === 'multiple' && this.renderMultipleFilter()}
        {this.props.type === 'ranged_date' && this.renderDateFilter()}
      </Container>
    );
  }
}

TransportOrderFilterFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: ownProps.separateFilter ? selectTransportOrderSeparateListFilter() : selectTransportOrderFilter(),

    searching: selectWork(REQUEST_COMPANIES_SEARCH),
    workUser: selectWork(REQUEST_USER),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(alt = false, additionalName) {
      dispatch(
        updateTransportOrderFilter(
          null,
          {
            reset: alt ? ownProps.altKey : additionalName || ownProps.name,
          },
          { separateFilter: ownProps.separateFilter },
        ),
      );
    },
    changeValues(values, labels = [], additionalName = null, rangedDate = null) {
      const type = rangedDate ?? ownProps.type;
      if (ownProps.inversed && !additionalName) {
        let inversed = values[0] === '1' ? false : true;
        let value = ['1'];
        dispatch(
          updateTransportOrderFilter(
            {
              key: additionalName || ownProps.name,
              value: values,
              label: labels,
              type: type,
              // inversed: true,
            },
            { separateFilter: ownProps.separateFilter },
          ),
        );

        return;
      }

      dispatch(
        updateTransportOrderFilter(
          {
            key: additionalName || ownProps.name,
            value: values,
            label: labels,
            type: type,
          },
          { separateFilter: ownProps.separateFilter },
        ),
      );
    },
    change(value, key, label = '') {
      dispatch(
        updateTransportOrderFilter(
          {
            key: key,
            value: [value.toString().toLowerCase()],
            label: [label],
            type: ownProps.type,
          },
          { separateFilter: ownProps.separateFilter },
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderFilter = compose(withConnect, withRouter, injectIntl)(TransportOrderFilterFilterComp);
